import React, { useEffect, useRef, useState } from 'react'
import { Miniapptopbar } from '../HomeUser/components';
import { Search } from '../components/Header/components'
import { Retrieve_personal_info, getS3fullpath_withbucketname, iconwrapper } from '../../../config/commonfunctions';
import { ABBREVCITY_ALLOW_ARR, ABBREVCITY_CURRENCY_MAP, ABBREV_PRESENCELOC_MAP, EMPTY, HOME_COLLECTION_VENDORTYPE_WEDDING, IMG_ALT, PRICELIST_FILTER_WEDDING, READABLE_PREACTUAL_MAP, READABLE_VENDORTYPE_MAP, TIER_DIAMOND_POSITION } from '../../../config/constants';
import { Checkdevicedetail, Loading, Portalmodal, ScreenHeight, ScreenWidth, refresh } from '../../../components';
import { USER_CHANGE_LOC, USER_PL_FIRST_READ_ALL, USER_PL_FIRST_READ_VTS, USER_PL_APPLYFILTER, USER_PL_SAVESETTINGSE, USER_PL_SAVESETTINGSW } from '../../../config/api';
import { Locationnotsupport, PricelistFilterModalContent } from '../components';
import axios from 'axios'
import './Pricelist.css'
import { BOARD_ICON, DOLLAR_ICON, FILTERTHIN_ICON, THICKHEART_ICON, LOCATION_ICON } from '../../../config/svgicons';
import { Link } from 'react-router-dom';

const minrange = 0
const maxrange = 50000
const minmaxstep = 100

const NONE = 0
const ASCENDING = 1
const DESCENDING = 2

const formatNumber = (num) => {
    if (Intl && Intl.NumberFormat) {
        try {
            return new Intl.NumberFormat('en', {
                notation: 'compact'
            }).format(num);
        } catch (e) { }
    }

    // fallback
    if (num >= 1000) {
        return (num / 1000).toFixed(0) + 'k';
    }
    return num.toString();
}

const Cards = (props) => {

    const { cardwt, cardht, namefs, wedtypefs, currencyfs, displaynamefs, vtfs, pldata, device } = props

    return pldata.map((item, index) => {
        const { _id, name, price, price_fixedval, price_rangestartval, price_rangeendval, currency, displayname, username, profileimg_id, curr_vendortype, logoimg, wedtype, vti_id, tags = [] } = item
        const { tier } = vti_id
        const { link } = profileimg_id
        const pldomclick = () => { document.getElementById('pldata_' + _id).click() }
        const vldomclick = () => { document.getElementById('vendorlookup' + username).click() }

        const solemnization_text = tags.length > 0 && tags.includes('Solemnization') ? ', Solemnization' : ''
        return <div className='Pricelistcard_root' key={_id} style={{ width: cardwt, height: cardht, border: '1px solid var(--lightdark)', fontFamily: 'Lato', borderRadius: 10, color: 'var(--maindark)', backgroundColor: '#ffffff', overflow: 'hidden', position: 'relative' }}>
            {tier === 0
                ? <div className='VCARD_DIAMONDROOT' style={{ position: 'absolute', zIndex: 1 }} />
                : <div className={`VCARD_DIAMONDROOT VCARD_DIAMONDROOT_${tier}`} style={{ position: 'absolute', zIndex: 1, height: 35, width: 35, top: 0, placeContent: 'center', right: 0, margin: 3, backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                    <div
                        className='VCARD_DIAMONDCONTENT'
                        style={{
                            backgroundImage: `url('https://asset.weavebliss.com/assets/sprites/diamonds.png')`,
                            backgroundPositionY: TIER_DIAMOND_POSITION[tier].y + 'px',
                            width: 23,
                            height: 23,
                            backgroundSize: 24,
                            position: 'absolute'
                        }}
                    />
                </div>}


            <div className="Pricelist_card_seccomp Pricelist_card_a" onClick={pldomclick}>
                <Link id={'pldata_' + _id} style={{ width: 0, height: 0, visibility: 'hidden' }} to={'/pricelistlookup/' + _id} target="_blank" />
                <img
                    alt={IMG_ALT}
                    src={getS3fullpath_withbucketname('VENDOR_PRICELIST_IMG', logoimg)}
                    onError={(img) => img.target.src = 'https://i.ibb.co/1qTdyzx/photo-1534428954988-f5e9a9690e9b.jpg'}
                    style={{ height: 180, maxHeight: '100%', maxWidth: '100%', minWidth: '100%', width: 'min-content', objectFit: device === 'MOBILE' ? 'cover' : 'fill' }}
                />
            </div>

            <div style={{ fontSize: namefs, padding: '10px 10px 0px 10px', width: '100%', cursor: 'pointer', overflow: 'hidden', whiteSpace: 'wrap' }} onClick={pldomclick}>{name}</div>

            <div style={{ fontSize: wedtypefs, padding: '0px 10px 0px', width: '100%', cursor: 'pointer' }} onClick={pldomclick}>{READABLE_PREACTUAL_MAP[wedtype] + solemnization_text}</div>

            {{
                'Fixed': <div style={{ fontSize: currencyfs, display: 'flex', padding: 10, width: '100%', cursor: 'pointer' }} onClick={pldomclick}>
                    {`$${price_fixedval} ${currency}`}
                </div>,
                'Range': <div style={{ fontSize: currencyfs, display: 'flex', flexDirection: 'row', padding: 10, width: '100%', cursor: 'pointer' }} onClick={pldomclick}>
                    <div>{`$${price_rangestartval}`}</div>
                    <div style={{ padding: '0px 3px' }}>{`-`}</div>
                    <div>{`$${price_rangeendval} ${currency}`}</div>
                </div>
            }[price]}
            <div className='Pricelist_card_btmnamevt' style={{ bottom: 0, position: 'absolute' }}>
                <Link id={'vendorlookup' + username} style={{ width: 0, height: 0, visibility: 'hidden' }} to={'/vendorlookup/' + username} target="_blank" />
                <div
                    className="Pricelist_card_a"
                    onClick={vldomclick}
                    style={{ display: 'flex', flexDirection: 'row', minHeight: '100%', width: '100%', alignItems: 'center', alignSelf: 'center', color: '#707070', fontSize: 12, padding: '12px 10px', color: 'var(--maindark)' }}
                >
                    <div style={{ minWidth: 40, minHeight: 40, marginRight: 5, backgroundImage: 'url(' + getS3fullpath_withbucketname('VENDOR_PROFILE_IMG', link) + ')', backgroundSize: 'cover', borderRadius: 100, border: '1px solid var(--subgrey)' }} />
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: 'transparent' }}>
                        <div style={{ fontSize: displaynamefs }}>{displayname}</div>
                        <div style={{ fontSize: vtfs, display: 'flex', flexDirection: 'row', color: 'var(--subdark)' }}>
                            {curr_vendortype.map((vt, i) => {
                                return i === 0 && curr_vendortype.length === 2
                                    ? <div key={index + '_' + i + '_' + vt} style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ whiteSpace: 'nowrap' }}>{READABLE_VENDORTYPE_MAP[vt]}</div>
                                        <div style={{ padding: '0px 2px', whiteSpace: 'nowrap' }}>/</div>
                                    </div>
                                    : <div key={index + '_' + i + '_' + vt}>{READABLE_VENDORTYPE_MAP[vt]}</div>
                            })}
                        </div>
                    </div>
                </div>
            </div>

        </div>

    })
}

const MobileCards = (props) => {

    const { cardwt, cardht, namefs, wedtypefs, currencyfs, displaynamefs, vtfs, pldata, device } = props

    return pldata.map((item, index) => {
        const { _id, name, price, price_fixedval, price_rangestartval, price_rangeendval, currency, displayname, username, profileimg_id, curr_vendortype, logoimg, wedtype, vti_id, tags = [] } = item
        const { tier } = vti_id
        const { link } = profileimg_id
        const pldomclick = () => { document.getElementById('pldata_' + _id).click() }
        const vldomclick = () => { document.getElementById('vendorlookup' + username).click() }

        const solemnization_text = tags.length > 0 && tags.includes('Solemnization') ? ', Solemnization' : ''
        return <div className='Pricelistcard_root' key={_id} style={{ width: cardwt, height: cardht, border: '1px solid var(--lightdark)', fontFamily: 'Lato', borderRadius: 10, color: 'var(--maindark)', backgroundColor: '#ffffff', overflow: 'hidden', position: 'relative' }}>
            {tier === 0
                ? <div className='VCARD_DIAMONDROOT' style={{ position: 'absolute', zIndex: 1 }} />
                : <div className={`VCARD_DIAMONDROOT VCARD_DIAMONDROOT_${tier}`} style={{ position: 'absolute', zIndex: 1, height: 35, width: 35, top: 0, placeContent: 'center', right: 0, margin: 3, backgroundColor: 'rgba(255, 255, 255, 0.5)' }}>
                    <div
                        className='VCARD_DIAMONDCONTENT'
                        style={{
                            backgroundImage: `url('https://asset.weavebliss.com/assets/sprites/diamonds.png')`,
                            backgroundPositionY: TIER_DIAMOND_POSITION[tier].y + 'px',
                            width: 23,
                            height: 23,
                            backgroundSize: 24,
                            position: 'absolute'
                        }}
                    />
                </div>}
            <div className="Pricelist_card_seccomp Pricelist_card_a" onClick={pldomclick}>
                <Link id={'pldata_' + _id} style={{ width: 0, height: 0, visibility: 'hidden' }} to={'/pricelistlookup/' + _id} target="_blank" />
                <img
                    alt={IMG_ALT}
                    src={getS3fullpath_withbucketname('VENDOR_PRICELIST_IMG', logoimg)}
                    onError={(img) => img.target.src = 'https://i.ibb.co/1qTdyzx/photo-1534428954988-f5e9a9690e9b.jpg'}
                    style={{ height: 180, maxHeight: '100%', maxWidth: '100%', minWidth: '100%', width: 'min-content', objectFit: device === 'MOBILE' ? 'contain' : 'fill', backgroundColor: 'black' }}
                />
            </div>

            <div style={{ fontSize: namefs, padding: '10px 10px 0px 10px', width: '100%', cursor: 'pointer', overflow: 'hidden', whiteSpace: 'wrap' }} onClick={pldomclick}>{name}</div>

            <div style={{ fontSize: wedtypefs, padding: '0px 10px 0px', width: '100%', cursor: 'pointer' }} onClick={pldomclick}>{READABLE_PREACTUAL_MAP[wedtype] + solemnization_text}</div>

            {{
                'Fixed': <div style={{ fontSize: currencyfs, display: 'flex', padding: 10, width: '100%', cursor: 'pointer' }} onClick={pldomclick}>
                    {`$${price_fixedval} ${currency}`}
                </div>,
                'Range': <div style={{ fontSize: currencyfs, display: 'flex', flexDirection: 'row', padding: 10, width: '100%', cursor: 'pointer' }} onClick={pldomclick}>
                    <div>{`$${price_rangestartval}`}</div>
                    <div style={{ padding: '0px 3px' }}>{`-`}</div>
                    <div>{`$${price_rangeendval} ${currency}`}</div>
                </div>
            }[price]}
            <div className='Pricelist_card_btmnamevt' style={{ bottom: 0, position: 'absolute' }}>
                <Link id={'vendorlookup' + username} style={{ width: 0, height: 0, visibility: 'hidden' }} to={'/vendorlookup/' + username} target="_blank" />
                <div
                    className="Pricelist_card_a"
                    onClick={vldomclick}
                    style={{ display: 'flex', flexDirection: 'row', minHeight: '100%', width: '100%', alignItems: 'center', alignSelf: 'center', color: '#707070', fontSize: 12, padding: '12px 10px', color: 'var(--maindark)' }}
                >
                    <div style={{ minWidth: 40, minHeight: 40, marginRight: 5, backgroundImage: 'url(' + getS3fullpath_withbucketname('VENDOR_PROFILE_IMG', link) + ')', backgroundSize: 'cover', borderRadius: 100, border: '1px solid var(--subgrey)' }} />
                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', backgroundColor: 'transparent' }}>
                        <div style={{ fontSize: displaynamefs }}>{displayname}</div>
                        <div style={{ fontSize: vtfs, display: 'flex', flexDirection: 'row', color: 'var(--subdark)' }}>
                            {curr_vendortype.map((vt, i) => {
                                return i === 0 && curr_vendortype.length === 2
                                    ? <div key={index + '_' + i + '_' + vt} style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div style={{ whiteSpace: 'nowrap' }}>{READABLE_VENDORTYPE_MAP[vt]}</div>
                                        <div style={{ padding: '0px 2px', whiteSpace: 'nowrap' }}>/</div>
                                    </div>
                                    : <div key={index + '_' + i + '_' + vt}>{READABLE_VENDORTYPE_MAP[vt]}</div>
                            })}
                        </div>
                    </div>
                </div>
            </div>

        </div>

    })
}

const filter_portalmidcss_web = {
    width: 600,
    height: 660,
    top: 'calc( 50% - 330px )',
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
}

const filter_portalmidcss_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none'
}

const filter_portalmidcsswtlarger_mobile = {
    width: '100%',
    height: '100%',
    top: 0,
    backgroundColor: 'white',
    left: 0, right: 0,
    margin: 'auto',
    transform: 'none',
    overflowX: 'scroll'
}

function Pricelist(props) {

    // for background only
    useEffect(() => {
        let previousbgcolor = ""
        let previousBgimage = ""

        document.body.style.backgroundColor = 'var(--bodypink)'
        document.body.style.backgroundImage = 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'
        return () => {
            document.body.style.backgroundColor = previousbgcolor || '';
            document.body.style.backgroundImage = previousBgimage || '';
        };
    }, [])

    const device = Checkdevicedetail()
    const screen_width = ScreenWidth()
    const screen_height = ScreenHeight()
    const { token } = Retrieve_personal_info()

    const [loading, setLoading] = useState(true)
    const [selectedvt, setSelectedvt] = useState('')
    const [selectedwedorevent, setSelecteedwedorevent] = useState('')
    const [selecteditem, setSelecteditem] = useState(null)
    const [abbrev_locations, setAbbrev_locations] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [scrolltop, setScrolltop] = useState(-1)

    // from first api call
    const [abbrev_userlocation, setAbbrev_userlocaation] = useState('')
    const [loc, setLoc] = useState('')
    const [totalpl, setTotalpl] = useState(0)
    const [batches, setBatches] = useState([])
    const [numbatch, setNumbatch] = useState(-1)
    const [totalfilternum, setTotalfilternum] = useState(0)
    const [totalpricenum, setTotalpricenum] = useState(0)

    // from second and subsequent api call
    const [data, setData] = useState([])

    // portal
    const [showprice, setShowprice] = useState(false)
    const [showfilter, setShowfilter] = useState(false)
    const [showlocation, setShowlocation] = useState(false)
    const [showquiz, setShowquiz] = useState(false)

    // filters
    const [filterpricelistsetting_w, setFilterpricelistsetting_w] = useState({})
    const [filterpricelistsetting_e, setFilterpricelistsetting_e] = useState({})
    const [filterpricelistrange_e, setFilterpricelistrange_e] = useState({})
    const [filterpricelistrange_w, setFilterpricelistrange_w] = useState({})


    // sldier value
    const [currency, setCurrency] = useState(EMPTY)
    const [modalminmax, setModalminmax] = useState([minrange, maxrange])
    const [rangereset, setRangereset] = useState(false)

    // refs for scroll handler to avoid stale closures
    const isFetchingBatchRef = useRef(false)
    const numbatchRef = useRef(-1)
    const batchesRef = useRef([])
    const scrollTimerRef = useRef(null)

    const fetchItems = (selectedvt, selectedwedorevent) => {

        const obtainbatchesdata = (arr, max) => {
            let data = [];
            for (let i = 0; i < arr.length; i += max) {
                data.push(arr.slice(i, i + max));
            }
            return data.slice()
        }

        function compareApl(a, b) {
            var a_first
            if (a.price === 'Fixed') {
                a_first = a.price_fixedval
            }
            else {
                a_first = a.price_rangestartval
            }

            var b_first
            if (b.price === 'Fixed') {
                b_first = b.price_fixedval
            }
            else {
                b_first = b.price_rangestartval
            }


            if (a_first < b_first) {
                return -1;
            }
            if (a_first > b_first) {
                return 1;
            }
            return 0;
        }

        function runpricesort(pl_ids, sort, renderpl_count) {


            var query_plids = []

            if (pl_ids.length > renderpl_count) {
                // out of pl_ids, pick renderpl_count number to retrieve the data obj

                // price sort
                if (sort == ASCENDING) { // ascending
                    pl_ids.sort(compareApl)
                    var i = pl_ids.length
                    while (i--) {
                        query_plids.push(pl_ids[0])
                        pl_ids.shift()
                    }
                }
                else if (sort == DESCENDING) { // descending
                    pl_ids.sort(compareApl).reverse()
                    var i = pl_ids.length
                    while (i--) {
                        query_plids.push(pl_ids[0])
                        pl_ids.shift()
                    }
                }
                else if (sort == NONE) { // none
                    var i = pl_ids.length
                    var j = 0;
                    while (i--) {
                        j = Math.floor(Math.random() * (pl_ids.length))
                        query_plids.push(pl_ids[j]);
                        pl_ids.splice(j, 1);
                    }
                }

            }
            else {
                query_plids = pl_ids.map((pl) => { return pl })
            }

            return query_plids

        }

        try {
            axios({
                method: 'POST',
                url: selectedvt === 'All' ? USER_PL_FIRST_READ_ALL : USER_PL_FIRST_READ_VTS,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                data: { "selectedvt": selectedvt, "selectedwedorevent": selectedwedorevent }
            })
                .then((result) => {
                    const { data, status } = result
                    const { error } = data
                    if (status === 200 && error === false) {
                        const {
                            abbrev_userlocation,
                            items,
                            renderpl_count,
                            filterpricelistsetting_w, filterpricelistsetting_e,
                            filterpricelistrange_e, filterpricelistrange_w,
                        } = data// number of card to render, supply by backend

                        if(ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation)){
                            setAbbrev_userlocaation(abbrev_userlocation)
                            setLoc(ABBREV_PRESENCELOC_MAP[abbrev_userlocation])
                            setCurrency(ABBREVCITY_CURRENCY_MAP[abbrev_userlocation])
    
                            setTotalpl(items.length)
    
                            setFilterpricelistsetting_w(JSON.parse(JSON.stringify(filterpricelistsetting_w)))
                            setFilterpricelistsetting_e(JSON.parse(JSON.stringify(filterpricelistsetting_e)))
                            setFilterpricelistrange_e(JSON.parse(JSON.stringify(filterpricelistrange_e)))
                            setFilterpricelistrange_w(JSON.parse(JSON.stringify(filterpricelistrange_w)))
    
                            setModalminmax([filterpricelistrange_w[selectedvt][abbrev_userlocation].min, filterpricelistrange_w[selectedvt][abbrev_userlocation].max])
    
    
                            // filter and sort
                            // let new_items = runpricesort(items, filterpricelistsetting_w[selectedvt]['pricesort'], renderpl_count)
                            let sort = filterpricelistsetting_w[selectedvt]['pricesort']
                            // console.log('items', items)
                            if (sort === ASCENDING) { items.sort(compareApl) }
                            if (sort === DESCENDING) { items.sort(compareApl).reverse() }
    
                            setBatches(obtainbatchesdata(items, renderpl_count))
    
                            let allfilters = filterpricelistsetting_w[selectedvt]['filteritem']
                            let local_totalpricenum = (allfilters.includes('Price ( High - Low )') || allfilters.includes('Price ( Low - High )')) ? 1 : 0
                            setTotalpricenum(local_totalpricenum)
                            setTotalfilternum(allfilters.length - local_totalpricenum < 0 ? 0 : allfilters.length - local_totalpricenum)
    
                            setNumbatch(0)
    
    
    
    
    
                        }
                
                        setLoading(false)

                    }
                })
                .catch(e => { 
                    alert(e)
                })
        }
        catch (e) {
            alert(e)
            console.log(e)
        }
    }



    // keep refs in sync with state
    useEffect(() => { numbatchRef.current = numbatch }, [numbatch])
    useEffect(() => { batchesRef.current = batches }, [batches])

    useEffect(() => {
        if (batches.length > 0 && numbatch === -1) {
            setNumbatch(0)  // trigger initial load only after batches is ready
        }
    }, [batches])


    useEffect(() => {

        setLoading(true)

        const { match } = props

        const vt = match?.params?.vt.toLowerCase()
        const wedorevent = match?.params?.wedorevent.toLowerCase()

        let selectedvt = vt[0].toUpperCase() + vt.slice(1) || ''
        let selectedwedorevent = wedorevent[0].toUpperCase() + wedorevent.slice(1) || ''

        setSelectedvt(selectedvt)
        setSelecteedwedorevent(selectedwedorevent)
        setSelecteditem(HOME_COLLECTION_VENDORTYPE_WEDDING.find(({ value }) => value === selectedvt))

        if (vt.length > 0) {
            fetchItems(selectedvt, selectedwedorevent)
        }

        const handleScroll = () => {
            clearTimeout(scrollTimerRef.current)
            scrollTimerRef.current = setTimeout(() => {
                const nearBottom =
                    window.innerHeight + window.scrollY >= document.body.offsetHeight - 200

                if (nearBottom && !isFetchingBatchRef.current && numbatchRef.current < batchesRef.current.length - 1) {
                    isFetchingBatchRef.current = true
                    setNumbatch(prev => prev + 1)
                }
            }, 300) // waits 300ms after user stops scrolling
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    useEffect(() => {
        if (numbatch > -1 && batches.length > 0) {
            const pl_ids = batches[numbatch]
            setData(prev => [...prev, ...pl_ids])  // ✅ functional update, no stale closure
            isFetchingBatchRef.current = false      // ✅ unblock next scroll trigger
        }
    }, [numbatch])

    useEffect(() => {
        // will only appear in Home, Wedding and Event page
        if (abbrev_userlocation) {
            var NEW_ABBREV_PRESENCE_LOCATION = [...Object.keys(ABBREVCITY_CURRENCY_MAP)]
            NEW_ABBREV_PRESENCE_LOCATION.splice(NEW_ABBREV_PRESENCE_LOCATION.indexOf(abbrev_userlocation), 1)
            NEW_ABBREV_PRESENCE_LOCATION.unshift(abbrev_userlocation)
            setAbbrev_locations(NEW_ABBREV_PRESENCE_LOCATION)
        }
    }, [abbrev_userlocation])

    const changeVt = (e) => {
        const { value } = e.currentTarget
        if (value) {

            const selectedvt = value[0].toUpperCase() + value.slice(1) || ''

            setSelectedvt(selectedvt)
            setSelecteditem(HOME_COLLECTION_VENDORTYPE_WEDDING.find(({ value }) => value === selectedvt))

            window.history.replaceState(null, '', `/pricelist/${selectedwedorevent.toLocaleLowerCase()}/${value.toLocaleLowerCase()}`)
            setDropdownOpen(false)

            setLoading(true)
            setData([])
            setNumbatch(-1)
            fetchItems(value, selectedwedorevent)
        }
    }

    const MOBILE_VT = (
        <div style={{ padding: '0px 10px 24px 10px', width: '100%', boxSizing: 'border-box', fontFamily: 'Lato' }}>

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: 5 }}>
                <button className='Vendor_mobilelocation' onClick={() => setShowlocation(true)}>{abbrev_userlocation.toUpperCase()}</button>
                <div className="Vendor_dropdownwrap">
                    <button
                        className={`Vendor_dropdowntrigger ${dropdownOpen ? 'Vendor_dropdowntrigger--open' : ''}`}
                        onClick={() => setDropdownOpen(o => !o)}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            {selecteditem?.icon && (
                                <div className="Vendor_dropdown_iconwrap">
                                    {iconwrapper(selecteditem.icon, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center', placeSelf: 'center' })}
                                </div>
                            )}
                            <span>{selectedvt ? READABLE_VENDORTYPE_MAP[selectedvt] : 'All Vendors'}</span>
                        </div>
                        <svg className={`Vendor_chevron ${dropdownOpen ? 'Vendor_chevron--open' : ''}`} width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M4 6l4 4 4-4" stroke="var(--maindark)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button>
                    {dropdownOpen && (
                        <div className="Vendor_dropdownlist">
                            {HOME_COLLECTION_VENDORTYPE_WEDDING.map(({ value, icon }, index) => {
                                const item = READABLE_VENDORTYPE_MAP[value]
                                const isSelected = selectedvt === value || (!selectedvt && value === 'All')
                                return (
                                    <button
                                        key={index + 'dd'}
                                        className={`Vendor_dropdownitem ${isSelected ? 'Vendor_dropdownitem--selected' : ''}`}
                                        value={value}
                                        onClick={changeVt}
                                    >
                                        <div className="Vendor_dropdown_iconwrap">
                                            {iconwrapper(icon, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center', placeSelf: 'center' })}
                                        </div>
                                        <span>{READABLE_VENDORTYPE_MAP[value]}</span>
                                        {isSelected && (
                                            <svg style={{ marginLeft: 'auto' }} width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M3 8l4 4 6-6" stroke="#e8799a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                            </svg>
                                        )}
                                    </button>
                                )
                            })}
                        </div>
                    )}
                </div>
            </div>

            <div className='Vendor_mobilefiltersortvendorfoundroot'>
                <div className='Vendor_mobilefiltersortroot'>

                    <button
                        className='Vendor_mobileheartbtn'
                        onClick={() => {
                            window.open('/favourite/vendor', '_blank');  // Open link in a new tab
                        }}
                    >
                        {iconwrapper(THICKHEART_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                    </button>

                    <button className='Vendor_mobilefilter' onClick={() => setShowprice(true)}>
                        {iconwrapper(DOLLAR_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        {totalpricenum === 0 ? null : <div className='Vendor_filternum'>{`${totalpricenum}`} </div>}
                    </button>

                    {selectedvt !== 'All'
                        ? <button
                            className='Vendor_mobilefilter'
                            onClick={() => {
                                document.body.style.overflow = 'hidden'
                                setShowfilter(true)
                            }}
                        >
                            {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21 })}
                            {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                        </button>
                        : null}

                </div>
                <div className='Vendor_mobilevendorfound'>{`${totalpl} Pricelist Found`}</div>
            </div>


            <div onClick={() => setShowprice(true)} className='Vendor_filterroot' style={{ width: '100%', margin: '5px 0px 0px 0px', display: 'flex', placeContent: 'flex-start', }}>
                <div style={{ border: '1px solid var(--maindark)', padding: '5px 10px', display: 'flex', flexDirection: 'column', borderRadius: 10, height: 45 }}>
                    <div style={{ fontSize: 10 }}>{`Price Range `}</div>
                    <div style={{ fontSize: 14 }}>{modalminmax[0] + ` ${currency} - ` + modalminmax[1] + ` ${currency}`}</div>
                </div>
            </div>

        </div>
    )

    const DESKTOP_VT = (
        <div style={{ padding: '0px 20px 24px 20px', width: '100%', boxSizing: 'border-box', fontFamily: 'Lato' }}>
            <div style={{ maxWidth: 1320, margin: '0 auto' }}>
                <div className="Vendor_itemroot">
                    <button
                        className='Vendor_filtersortbtnleft'
                        style={{ placeSelf: 'flex-start', display: 'flex', flexDirection: 'row', marginBottom: 5 }}
                        onClick={() => setShowlocation(true)}
                    >
                        {iconwrapper(LOCATION_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        {loc}
                    </button>
                    <div className="Vendor_itemsubroot">
                        {HOME_COLLECTION_VENDORTYPE_WEDDING.map(({ value, icon, }, index) => {
                            // const item = READABLE_VENDORTYPE_MAP[value]
                            const isSelected = selectedvt === value || (!selectedvt && value === 'All')
                            return (
                                <button
                                    className={`Vendor_singleitemroot ${isSelected ? 'Vendor_singleitemroot--selected' : ''}`}
                                    value={value}
                                    onClick={changeVt}
                                    key={index + 'vt'}
                                >
                                    {value === 'All'
                                        ? <>
                                            <div className="Vendor_singleitemname" style={{ height: '100%', placeItems: 'center' }}>{`All\nVendors`}</div>
                                        </>
                                        : <>
                                            <div className="Vendor_iconwrap">
                                                {iconwrapper(icon, { width: 25, height: 25 })}
                                            </div>
                                            <div className="Vendor_singleitemname">{READABLE_VENDORTYPE_MAP[value]}</div>
                                        </>}
                                </button>
                            )
                        })}
                    </div>
                </div>
            </div>


            <div className='Vendor_filterroot' style={{ maxWidth: 1320, margin: '0 auto' }}>
                <div className='Vendor_filtersortrow' >
                    <div className='Vendor_filtersortroot' >

                        {/* <button className='Vendor_locationbtn' onClick={() => setShowlocation(true)}>{abbrev_userlocation.toUpperCase()}</button> */}



                        <button
                            className='Vendor_filtersortbtnleftheart'
                            onClick={() => { window.open('/favourite/vendor', '_blank'); }}
                        >
                            {iconwrapper(THICKHEART_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                        </button>


                        <button
                            className='Vendor_filtersortbtnleft'
                            onClick={() => {
                                document.body.style.overflow = 'hidden'
                                setShowprice(true)
                            }}
                        >
                            {iconwrapper(DOLLAR_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                            {totalpricenum === 0 ? null : <div className='Vendor_filternum'>{`${totalpricenum}`} </div>}
                        </button>

                        <div className='Vendor_filtersortbtnleft' onClick={() => setShowprice(true)} style={{ width: 'max-content', maxWidth: 150, padding: '0px 10px', backgroundColor: 'transparent', border: '1px solid var(--maindark)' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', borderRadius: 10, height: 45, placeContent: 'center' }}>
                                <div style={{ fontSize: 10 }}>{`Price Range `}</div>
                                <div style={{ fontSize: 14 }}>{formatNumber(modalminmax[0]) + ` - ` + formatNumber(modalminmax[1]) + ` ${currency}`}</div>
                                {/* <div style={{ fontSize: 14 }}>{formatNumber(modalminmax[0]) + ` ${currency} - ` + formatNumber(modalminmax[1]) + ` ${currency}`}</div> */}
                            </div>
                        </div>

                        {selectedvt !== 'All'
                            ? <button
                                className='Vendor_filtersortbtnleft'
                                onClick={() => {
                                    document.body.style.overflow = 'hidden'
                                    setShowfilter(true)
                                }}
                            >
                                {iconwrapper(FILTERTHIN_ICON, { width: 21, height: 21, display: 'flex', placeContent: 'center', placeItems: 'center' })}
                                {totalfilternum === 0 ? null : <div className='Vendor_filternum'>{`${totalfilternum}`} </div>}
                            </button>
                            : null}

                    </div>
                    <div className='Vendor_numlabel'>{`${totalpl} Pricelist Found`}</div>
                </div>
            </div>


        </div>
    )


    const apply = ({
        checkedheadernames,
        modalminmax
    }) => {

        // const { currvt, currcat, filters, minp, maxp, sort } = req.body

        let sort = NONE
        if (checkedheadernames.includes('Price ( High - Low )')) {
            sort = DESCENDING
        }
        else if (checkedheadernames.includes('Price ( Low - High )')) {
            sort = ASCENDING
        }

        setShowfilter(false)
        setShowprice(false)

        document.getElementById('app-root').style.overflowY = ''
        if (device === 'MOBILE') {
            document.body.style.position = ''
            document.documentElement.scrollTop = scrolltop
            setScrolltop(-1)
        }
        document.body.style.overflow = ''

        setLoading(true)
        setNumbatch(-1)
        setData([])
        setBatches([])

        setModalminmax(modalminmax)

        try {
            axios({
                method: 'POST',
                url: USER_PL_SAVESETTINGSW, //USER_PL_SAVESETTINGSE,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }, //need token from the web
                data: { currvt: selectedvt, filters: checkedheadernames, minp: modalminmax[0], maxp: modalminmax[1], sort, loc }
            }).then((result) => {

                const { data, status } = result
                const { error } = data
                if (status === 200 && error === false) {
                    fetchItems(selectedvt, selectedwedorevent)
                }

            })


        }
        catch (e) {
            // window.location = '/'
        }

    }


    const PRICE_PORTAL = <Portalmodal
        title={'Price'}
        portaltype={'commonportal'}
        open={showprice}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowprice(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? filter_portalmidcss_web : screen_width > screen_height ? filter_portalmidcsswtlarger_mobile : filter_portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
    >
        <div className='Portalmodal_vtroot'>



            <PricelistFilterModalContent
                apply={apply}
                availablefilters={PRICELIST_FILTER_WEDDING}
                filtersetting={filterpricelistsetting_w}
                usertype={'Wedding'}
                priceorfilter={'PRICE'}
                selectedVendorType={selectedvt}

                //slider related states
                selectedwedorevent={selectedwedorevent}
                reset={() => {
                    setModalminmax([minrange, maxrange])
                    setRangereset(true)
                }}
                currency={currency}
                minmaxstep={minmaxstep}
                minrange={minrange}
                maxrange={maxrange}
                modalminmax={modalminmax}
                rangereset={rangereset}


            />
        </div>
    </Portalmodal>

    const FILTER_PORTAL = <Portalmodal
        title={'Filter'}
        portaltype={'commonportal'}
        open={showfilter}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowfilter(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={(device === 'WEB' || device === 'TABLET') ? filter_portalmidcss_web : screen_width > screen_height ? filter_portalmidcsswtlarger_mobile : filter_portalmidcss_mobile}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
    >
        <div className='Portalmodal_vtroot'>

            <PricelistFilterModalContent
                apply={apply}
                availablefilters={PRICELIST_FILTER_WEDDING}
                filtersetting={filterpricelistsetting_w}
                usertype={'Wedding'}
                priceorfilter={'FILTER'}
                selectedVendorType={selectedvt}

                //slider related states
                selectedwedorevent={selectedwedorevent}
                reset={() => {
                    setModalminmax([minrange, maxrange])
                    setRangereset(true)
                }}
                currency={currency}
                minmaxstep={minmaxstep}
                minrange={minrange}
                maxrange={maxrange}
                modalminmax={modalminmax}
                rangereset={rangereset}
            />
        </div>
    </Portalmodal>

    const LOCATION_PORTAL = <Portalmodal
        portaltype={'commonportal'}
        open={showlocation}
        onClose={() => {
            document.getElementById('app-root').style.overflowY = ''
            if (device === 'MOBILE') {
                document.body.style.position = ''
                document.documentElement.scrollTop = scrolltop
                setScrolltop(-1)
            }
            document.body.style.overflow = ''
            setShowlocation(false)
        }}
        floatingclose={false}
        backdropvisible={true}
        modalstyle={{
            height: device === 'MOBILE' ? '100%' : 'max-content',
            width: device === 'MOBILE' ? '100%' : 450
        }}
        closestyle={{ right: 0 }}
        floatingclosecolor='var(--maindark)'
        title={'Location'}
    >
        <div className='Portalmodal_vtroot'>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', overflowY: 'auto', marginBottom: 10 }}>
                {abbrev_locations.map((val, i) => {
                    return <div
                        className={abbrev_userlocation === val ? 'Portalinnerelem_selected' : 'Portalinnerelem'}
                        style={{
                            borderRadius: i === 0 ? '10px 10px 0px 0px' : i === abbrev_locations.length - 1 ? '0px 0px 10px 10px' : '0px',
                            cursor: 'pointer'
                        }}
                        key={val}
                        onClick={() => {
                            try {
                                let options = {
                                    method: 'POST',
                                    url: USER_CHANGE_LOC,
                                    headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' },
                                    data: { new_loc: ABBREV_PRESENCELOC_MAP[val.toLowerCase()] }
                                }
                                axios(options).then(() => {
                                    refresh()
                                }).catch((e) => {
                                    refresh()
                                })
                            }
                            catch (e) {
                                refresh()
                            }
                        }}
                    >
                        <div className="locationselector_val">{val.toUpperCase()}</div>
                        <div className="locationselector_locitem">{ABBREV_PRESENCELOC_MAP[val]}</div>
                    </div>
                })}
            </div>
        </div>
    </Portalmodal>

    return !loading
        ? <div className='Pricelist_root'>
            <Miniapptopbar {...props} currentpage={'PRICELIST'}abbrev_userlocation={abbrev_userlocation} />
            <Search
                {...props}
                wrapperstyle={{ width: '100%', padding: '24px 10px', }}
            // wrapperstyle={{backgroundColor: '#fff1f4',width:'100%', padding:'24px 10px', backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, rgba(0, 0, 0, 0.03) 5px, rgba(0, 0, 0, 0.03) 4px)'}}
            />
            {ABBREVCITY_ALLOW_ARR.includes(abbrev_userlocation)
                ? <>
                    {device === 'MOBILE' ? MOBILE_VT : DESKTOP_VT}
                    <div style={{ maxWidth: '100%', display: 'flex', placeItems: 'center', placeContent: 'center' }}>
                        <div
                            className="vendor-cardsroot"
                            style={{ width: device === 'WEB' ? 1320 : '100%', padding: { WEB: '30px 0px', WTINBTW: '30px 0px', TABLET: '30px 0px', SMALLTABLET: '0px 0px', MOBILE: '0px 10px' }[device] }}
                        >

                            {(data && data.length > 0 && (device === 'WEB' || device === 'TABLET' || device === 'WTINBTW'))
                                ? <Cards
                                    {...props}
                                    pldata={data}
                                    cardwt={300}
                                    cardht={380}
                                    namefs={16}
                                    wedtypefs={12}
                                    currencyfs={18}
                                    displaynamefs={14}
                                    vtfs={12}
                                    device={device}
                                />
                                : null}

                            {(data && data.length > 0 && device === 'SMALLTABLET')
                                ? <Cards
                                    {...props}
                                    pldata={data}
                                    cardwt={300}
                                    cardht={380}
                                    namefs={16}
                                    wedtypefs={12}
                                    currencyfs={18}
                                    displaynamefs={14}
                                    vtfs={12}
                                    device={device}
                                />
                                : null}

                            {(data && data.length > 0 && device === 'MOBILE')
                                ? <MobileCards
                                    {...props}
                                    pldata={data}
                                    cardwt={'100%'}
                                    cardht={380}
                                    namefs={16}
                                    wedtypefs={12}
                                    currencyfs={18}
                                    displaynamefs={14}
                                    vtfs={12}
                                    device={device}
                                />
                                : null}
                        </div>
                    </div>

                    {LOCATION_PORTAL}
                    {FILTER_PORTAL}
                    {PRICE_PORTAL}
                </>
                :<Locationnotsupport from='PRICELIST' />}


        </div>
        : <Loading />

}

export default Pricelist